// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../../autocomplete/AutocompleteV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SelectInputTextSize = require("../../../common/Form/SelectInputTextSize.bs.js");

function toString(v) {
  if (v === "Condo") {
    return "Condo/Townhouse";
  } else if (v === "Lot") {
    return "Lot";
  } else if (v === "MultiUnit") {
    return "Multi-unit";
  } else {
    return "Single-family";
  }
}

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return toString(x.value);
}

function make(v) {
  return {
    value: v,
    label: toString(v)
  };
}

let PropertyTypeOption = {
  toString: toString,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  make: make
};

function PropertyTypeSelect(props) {
  let status = props.status;
  let onChange = props.onChange;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
      getOptionLabel: getOptionLabel,
      getOptionValue: getOptionValue,
      onBlur: props.onBlur,
      onChange: v => {
        let v$1 = Stdlib_Option.map(v, param => param.value);
        if (onChange !== undefined) {
          return onChange(v$1);
        }
      },
      onFocus: props.onFocus,
      options: props.options,
      value: Stdlib_Option.map(props.value, make),
      status: status !== undefined ? (
          status === "ok" ? "Success" : "Failure"
        ) : "Neutral"
    }),
    className: SelectInputTextSize.className
  });
}

let make$1 = PropertyTypeSelect;

exports.PropertyTypeOption = PropertyTypeOption;
exports.make = make$1;
/* AutocompleteV5 Not a pure module */
